export default __webpack_public_path__ + "static/join-45a437f5f664bf48b771bb2f376bc640.svg";